import {
  type NilHundredResponseNil100FilterResponseRelatedPagedData,
  type NilRankingResponseRelatedNilRankingResponseRelatedPagedData,
  type PersonValuationResponse,
  type PlayerProfileResponse,
  type PublicPlayerDealResponsePagedData,
  type ValuationGrowthResponse,
} from '@on3/api';
import { MobileMPU } from '@public/components/Ads/MobileMPU';
import { NilTopFive } from '@public/components/Db/Profile/Nil/NilTopFive';
import { PlayerSearch } from '@public/components/Db/Profile/PlayerSearch';
import { ProfileValuationModule } from '@public/components/Db/Profile/ProfileValuationModule';
import { DatabaseLayout } from '@public/components/Layouts/DatabaseLayout';
import { PlayerNilDeals } from '@public/components/Nil/DealTracker/PlayerNilDeals';
import { AdminLink } from '@public/components/User/AdminLink';
import { useAthlete } from '@public/contexts/AthleteProvider';

import { PlayerHeader } from '../PlayerHeader';
import styles from './PlayerNIL.module.scss';

export interface PlayerNilPageProps {
  latestValuation?: PersonValuationResponse | null;
  valuationGrowth?: ValuationGrowthResponse | null;
  playerDeals?: PublicPlayerDealResponsePagedData | null;
  nil100?: NilHundredResponseNil100FilterResponseRelatedPagedData | null;
  nilSport?: NilRankingResponseRelatedNilRankingResponseRelatedPagedData | null;
  nilTeam?: NilHundredResponseNil100FilterResponseRelatedPagedData;
}

export const PlayerNIL = ({
  latestValuation,
  valuationGrowth,
  nil100,
  nilSport,
  nilTeam,
  playerDeals,
}: PlayerNilPageProps) => {
  const { athlete } = useAthlete();
  const hasPlayerDeals = !!playerDeals?.list?.length;

  return (
    <DatabaseLayout>
      <div className={styles.block}>
        <AdminLink path={`/people/${athlete?.slug}/edit/`} />

        <section className={styles.playerDetail}>
          <header>
            <h1>{athlete?.name}</h1>
            <PlayerSearch />
          </header>
          <PlayerHeader player={athlete as PlayerProfileResponse} />
        </section>

        <section className={styles.nil}>
          <ProfileValuationModule
            latestValuation={latestValuation}
            valuationGrowth={valuationGrowth}
          />
        </section>

        <MobileMPU id="mobile_mpu_middle" incontent />

        <div className={styles.modules}>
          {hasPlayerDeals && (
            <section className={styles.deals}>
              <h2>NIL Deal Tracker</h2>
              <PlayerNilDeals playerDeals={playerDeals} />
            </section>
          )}
          <NilTopFive
            color="#0d8bff"
            nil100={nil100}
            nilSport={nilSport}
            nilTeam={nilTeam}
          />
        </div>
      </div>
    </DatabaseLayout>
  );
};
